var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVials(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488 32H312C298.801 32 288 42.799 288 56C288 69.199 298.801 80 312 80H320V396.459C320 438.223 350.467 475.574 392.033 479.611C439.723 484.244 480 446.754 480 400V80H488C501.199 80 512 69.199 512 56C512 42.799 501.199 32 488 32ZM432 256H368V80H432V256ZM200 32H24C10.801 32 0 42.799 0 56C0 69.199 10.801 80 24 80H32V396.459C32 438.223 62.467 475.574 104.033 479.611C151.723 484.244 192 446.754 192 400V80H200C213.199 80 224 69.199 224 56C224 42.799 213.199 32 200 32ZM144 256H80V80H144V256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVials);
export default __webpack_public_path__ + "static/media/vials.210f851c788fe1b8a9f219fc8ea09773.svg";
export { ForwardRef as ReactComponent };